/**
 * Route gate: platform admin OR chartMindIAccess grant.
 *
 * Unsigned visitors go to sign-in with a return path. Signed-in accounts
 * without a grant see an access-denied page (ChartMind-I has no marketing
 * waitlist counterpart to ClinicalHUD's request-access).
 */
import { Navigate, useLocation } from "react-router-dom";
import { Alert, Box, Typography } from "@mui/material";
import Loading from "components/Loading";
import { useAuth } from "hooks/useAuth";
import { useChartMindIAccess } from "../hooks/useChartMindIAccess";

export default function RequireChartMindIAccess({ children }) {
  const { user } = useAuth();
  const { canAccess, loading } = useChartMindIAccess();
  const location = useLocation();

  if (loading) return <Loading page />;
  if (canAccess) return children;
  if (!user) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/auth?next=${encodeURIComponent(next)}`} replace />;
  }
  return (
    <Box sx={{ maxWidth: 560, mx: "auto", py: 6, px: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        ChartMind-I
      </Typography>
      <Alert severity="warning">
        Your account does not have ChartMind-I access. Ask a platform admin to
        issue a <code>chartMindIAccess</code> grant.
      </Alert>
    </Box>
  );
}
